/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEmbedYoutubeAndContentViewProps } from './embed-youtube-and-content';
import { RichTextComponent } from '@msdyn365-commerce/core';

export default (props: IEmbedYoutubeAndContentViewProps) => {
    const { title, description, videoDetails } = props;
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                className='row_begin_your_build'
                data-enable-parallax={0}
                data-parallax-speed='0.5'
                data-background-images='{}'
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src
                data-element='inner'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <h3
                    data-content-type='heading'
                    data-appearance='default'
                    data-element='main'
                    style={{ textAlign: 'center', borderStyle: 'none', borderWidth: '1px', borderRadius: '0px' }}
                >
                    {title}
                </h3>
                <div
                    className='pagebuilder-column-group'
                    data-content-type='column-group'
                    data-grid-size={12}
                    data-element='main'
                    style={{ display: 'flex' }}
                >
                    <div
                        className='pagebuilder-column'
                        data-content-type='column'
                        data-appearance='full-height'
                        data-background-images='{}'
                        data-element='main'
                        style={{
                            justifyContent: 'flex-start',
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundPosition: 'left top',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundAttachment: 'scroll',
                            borderStyle: 'none',
                            borderWidth: '1px',
                            borderRadius: '0px',
                            width: '50%',
                            margin: '0px',
                            padding: '10px',
                            alignSelf: 'stretch'
                        }}
                    >
                        <div
                            data-content-type='text'
                            data-appearance='default'
                            data-element='main'
                            style={{
                                textAlign: 'left',
                                borderStyle: 'none',
                                borderWidth: '1px',
                                borderRadius: '0px',
                                margin: '0px',
                                padding: '0px'
                            }}
                        >
                            <RichTextComponent text={description} />
                        </div>
                    </div>
                    <div
                        className='pagebuilder-column'
                        data-content-type='column'
                        data-appearance='full-height'
                        data-background-images='{}'
                        data-element='main'
                        style={{
                            justifyContent: 'flex-start',
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundPosition: 'left top',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundAttachment: 'scroll',
                            borderStyle: 'none',
                            borderWidth: '1px',
                            borderRadius: '0px',
                            width: '50%',
                            margin: '0px',
                            padding: '10px',
                            alignSelf: 'stretch'
                        }}
                    >
                        <div
                            data-content-type='text'
                            data-appearance='default'
                            data-element='main'
                            style={{
                                borderStyle: 'none',
                                borderWidth: '1px',
                                borderRadius: '0px',
                                margin: '0px',
                                padding: '0px'
                            }}
                        >
                            <p id='VF0VP6N' style={{ textAlign: 'center' }}>
                                <strong>{videoDetails.videoCaption}</strong>
                            </p>
                        </div>
                        <div data-content-type='video' data-appearance='default' data-element='main' style={{ margin: '0px' }}>
                            <div className='pagebuilder-video-inner' data-element='inner'>
                                <div
                                    className='pagebuilder-video-wrapper'
                                    data-element='wrapper'
                                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', padding: '0px' }}
                                >
                                    <div className='pagebuilder-video-container'>
                                        <iframe
                                            frameBorder={0}
                                            allowFullScreen={videoDetails.allowFullscreen}
                                            src={videoDetails.videoUrl?.destinationUrl}
                                            data-element='video'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
